import React from "react";
import { STATE_TILES } from "../lib/stateTiles";

const TIER_RING = {
    gold: "ring-[hsl(40_75%_55%)]",
    silver: "ring-[hsl(40_10%_70%)]",
    bronze: "ring-[hsl(25_45%_45%)]",
};

const STATUS_BG = {
    available: "bg-[hsl(40_50%_30%/0.35)] hover:bg-[hsl(40_60%_45%/0.55)] text-[hsl(40_70%_85%)]",
    locked: "bg-[hsl(151_55%_18%)] text-[hsl(151_25%_75%)] opacity-60 hover:opacity-90",
    warning: "bg-[hsl(350_65%_35%/0.75)] text-[hsl(0_0%_98%)] pulse-warning",
};

export default function USMap({ territories = [], onSelect, selectedCode }) {
    const byCode = Object.fromEntries(territories.map((t) => [t.state_code, t]));

    const rows = 8;
    const cols = 13;
    const grid = Array.from({ length: rows }, () => Array.from({ length: cols }, () => null));
    STATE_TILES.forEach((t) => {
        grid[t.row][t.col] = t;
    });

    return (
        <div className="w-full" data-testid="us-territory-map">
            <div
                className="grid gap-1.5"
                style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}
            >
                {grid.flatMap((row, ri) =>
                    row.map((tile, ci) => {
                        if (!tile) {
                            return (
                                <div
                                    key={`${ri}-${ci}-empty`}
                                    className="aspect-square"
                                    aria-hidden="true"
                                />
                            );
                        }
                        const data = byCode[tile.code] || { status: "available", tier: "bronze" };
                        const selected = selectedCode === tile.code;
                        return (
                            <button
                                key={tile.code}
                                type="button"
                                onClick={() => onSelect && onSelect(data.state_code ? data : { ...tile, ...data })}
                                data-testid={`state-tile-${tile.code}`}
                                className={`map-tile aspect-square flex flex-col items-center justify-center rounded-md text-xs font-mono tracking-tight ring-1 ring-inset ${TIER_RING[data.tier]} ${STATUS_BG[data.status]} ${selected ? "outline outline-2 outline-[hsl(45_85%_68%)] -translate-y-0.5" : ""}`}
                                title={`${tile.name} — ${data.tier?.toUpperCase()} (${data.status})`}
                            >
                                <span className="font-semibold text-[11px]">{tile.code}</span>
                                <span className="text-[8px] opacity-70">{data.tier?.[0]?.toUpperCase()}</span>
                            </button>
                        );
                    }),
                )}
            </div>
        </div>
    );
}
